/*
 * "Request a sample": one unbranded unit, posted by whoever makes it.
 *
 * Not a cart line. Selling a single unit at retail loses money, and a buyer
 * deciding on five hundred wants to hold one first — so we take the address
 * and mail the maker.
 */
(function () {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  function start() {
    // A panel, not a <form>: it sits inside the theme's /cart/add form, and a
    // nested form is dropped by the parser.
    var form = document.querySelector('[data-sb-sample]');
    var opener = document.querySelector('[data-sb-sample-open]');
    if (!form || !opener) return;

    var status = form.querySelector('[data-sb-sample-status]');
    var send = form.querySelector('[data-sb-sample-send]');
    var field = function (name) { return form.querySelector('[name="' + name + '"]'); };
    var value = function (name) { var el = field(name); return el ? el.value.trim() : ''; };

    function say(message, isError) {
      if (!status) return;
      status.textContent = message;
      status.hidden = false;
      status.classList.toggle('is-error', !!isError);
    }

    opener.addEventListener('click', function () {
      var open = form.hidden;
      form.hidden = !open;
      opener.setAttribute('aria-expanded', String(open));
      if (open) {
        var first = form.querySelector('input, textarea');
        if (first) first.focus();
      }
    });

    // The variant the buyer is actually looking at, read at send time rather
    // than at page load — they may have switched colour since.
    document.addEventListener('variant:change', function (e) {
      var id = e && e.detail && e.detail.variant && e.detail.variant.id;
      if (id) form.dataset.variantId = id;
    });

    send.addEventListener('click', async function () {
      var body = {
        productId: form.dataset.productId,
        variantId: form.dataset.variantId,
        name: value('name'),
        email: value('email'),
        company: value('company'),
        phone: value('phone'),
        address: value('address'),
        notes: value('notes'),
      };

      // Without a form element there is no native validation, and the server's
      // message is the one that matters anyway -- but say it before the trip.
      if (!body.name || !body.email || !body.address) {
        say('Please give us a name, a work email and somewhere to send it.', true);
        return;
      }

      send.disabled = true;
      var label = send.textContent;
      send.textContent = 'Sending…';
      say('', false);
      status.hidden = true;

      try {
        var res = await fetch('/apps/blazon/api/sample', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        var out = await res.json();
        if (!res.ok || !out.ok) throw new Error(out.error || 'We could not send that request.');

        ['name', 'email', 'company', 'phone', 'address', 'notes'].forEach(function (n) {
          var el = field(n);
          if (el) el.value = '';
        });
        say(out.message + ' Reference #' + out.reference, false);
        send.hidden = true;
      } catch (err) {
        say(err.message, true);
        send.disabled = false;
        send.textContent = label;
      }
    });
  }
})();
